function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import { useTheme } from "@mui/material/styles";
//Limitless imports
import { smileyAmber, smileyRed, smileyGreen, smileyConfoundedFace, smileySlightlyFrowningFace, smileyConfusedFace, smileyNeutralFace, smileyWhiteSmilingFace, smileyRelievedFace, smilingFaceWithOpenMouthAndSmilingEyes } from "@limitless/images";
import CustomerButton from "../../../customer-button/CustomerButton";
const SmileyRatingSystem = ({
  classes,
  onClick,
  disabled,
  rating,
  compact,
  containerClass,
  schemeName,
  onHover = null
}) => {
  const [localRating, setLocalRating] = React.useState(rating);
  const [hover, setHover] = React.useState();
  const theme = useTheme();
  React.useEffect(() => {
    setLocalRating(rating);
  }, [rating]);
  const renderSmiley = (assetName, id, score, unselectedOpacity) => {
    const selected = localRating === score;
    const hide = !selected && compact;
    let selectedStyle = {};
    let buttonStyles = {};
    let compactStyles = {};
    let hoverStyles = {};
    const {
      buttonSelected,
      buttonUnSelected,
      smileyHover,
      csatSimleyButton,
      compactStyle
    } = getStyle(theme, schemeName);
    if (localRating !== -1) {
      selectedStyle = selected ? buttonSelected : buttonUnSelected;
      buttonStyles = selected ? {} : {
        opacity: unselectedOpacity
      };
    }
    if (compact) {
      compactStyles = compactStyle;
    }
    if (hover === id) {
      hoverStyles = smileyHover;
    }
    let props = {
      disabled,
      component: "div",
      style: hide ? {
        display: "none"
      } : {
        ...buttonStyles,
        ...csatSimleyButton,
        ...selectedStyle,
        ...hoverStyles,
        ...compactStyles
      },
      onMouseEnter: () => {
        setHover(id);
        if (typeof onHover === "function") {
          onHover(score);
        }
      },
      onMouseLeave: () => {
        setHover();
        if (typeof onHover === "function") {
          onHover();
        }
      }
    };
    if (!disabled) {
      props = {
        onClick: () => {
          setLocalRating(score);
          onClick(score);
        },
        ...props
      };
    }
    return /*#__PURE__*/React.createElement(CustomerButton, _extends({}, props, {
      id: id
    }), /*#__PURE__*/React.createElement("img", {
      src: assetName,
      className: `${classes.smileyImage} ${schemeName === "7-faces" ? classes.maxFacesSmiley : classes.minFacesSmiley} ${selected && !compact ? classes.smileyImageSelected : ""}`
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.smileyContainer} ${containerClass}`,
    rating: localRating
  }, schemeName === "3-faces" ? /*#__PURE__*/React.createElement(React.Fragment, null, renderSmiley(smileyRed, "redVoteButton", 1, 0.4), renderSmiley(smileyAmber, "amberVoteButton", 2, 1), renderSmiley(smileyGreen, "greenVoteButton", 3, 0.7)) : schemeName === "7-faces" && /*#__PURE__*/React.createElement(React.Fragment, null, renderSmiley(smileyConfoundedFace, "smileyConfoundedFaceVote", 1, 1), renderSmiley(smileySlightlyFrowningFace, "smileySlightlyFrowningFaceVote", 2, 1), renderSmiley(smileyConfusedFace, "smileyConfusedFaceVote", 3, 1), renderSmiley(smileyNeutralFace, "smileyNeutralFaceVote", 4, 1), renderSmiley(smileyRelievedFace, "smileyRelievedFaceVote", 5, 1), renderSmiley(smileyWhiteSmilingFace, "smileyWhiteSmilingFaceVote", 6, 1), renderSmiley(smilingFaceWithOpenMouthAndSmilingEyes, "smilingFaceWithOpenMouthAndSmilingEyesVote", 7, 1)));
};
const getStyle = ({
  palette
}, schemeName) => {
  let smileySelectedBackground = "#f5f5f5";
  let smileySelectedBorderColor = "1px solid rgba(163,168,168, 0.5)";
  let smileySelectedBorderRadius = 4;
  if (palette.smiley) {
    smileySelectedBackground = palette.smiley.fill;
    smileySelectedBorderColor = palette.smiley.border;
    smileySelectedBorderRadius = palette.smiley.borderRadius;
  }
  return {
    csatSimleyButton: {
      padding: 1,
      boxShadow: "none",
      cursor: "pointer",
      border: 0,
      borderRadius: 0,
      height: 52,
      width: schemeName === "7-faces" ? 40 : 64,
      minWidth: schemeName === "7-faces" ? 30 : 64,
      "&:disabled": {
        cursor: "default",
        opacity: "0.2"
      },
      "&:focus": {
        outline: "none"
      },
      backgroundColor: "transparent"
    },
    buttonSelected: {
      backgroundColor: smileySelectedBackground,
      borderRadius: smileySelectedBorderRadius,
      border: smileySelectedBorderColor,
      margin: 0
    },
    buttonUnSelected: {
      filter: "grayscale(100%)"
    },
    smileyHover: {
      backgroundColor: smileySelectedBackground,
      borderRadius: smileySelectedBorderRadius,
      filter: "none",
      opacity: "1 !important"
    },
    compactStyle: {
      transform: "scale(0.9)",
      height: "unset",
      width: "unset",
      backgroundColor: "unset",
      padding: 0,
      minWidth: "unset",
      border: "none"
    }
  };
};
const styles = () => {
  return {
    smileyImage: {
      transition: "all .2s linear",
      "&:hover": {
        transform: "scale(1.15)"
      }
    },
    smileyImageSelected: {
      transform: "scale(1.15)"
    },
    smileyContainer: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    },
    buttonDisabled: {
      "&:hover, &.Mui-focusVisible": {
        backgroundColor: "transparent"
      },
      cursor: "default"
    },
    minFacesSmiley: {
      height: 32,
      width: 32
    },
    maxFacesSmiley: {
      height: 25,
      width: 25
    }
  };
};
export default withStyles(styles)(SmileyRatingSystem);
SmileyRatingSystem.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  rating: PropTypes.number.isRequired,
  compact: PropTypes.bool,
  containerClass: PropTypes.string,
  schemeName: PropTypes.string,
  onHover: PropTypes.func
};
SmileyRatingSystem.defaultProps = {
  compact: false
};